module.exports = __webpack_public_path__ + "img/message-smile.c9b975d4.svg";